import { FC, Fragment, useReducer } from 'react';

import { Plus } from 'lucide-react';
import { addProp } from 'remeda';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';

import { initialValues } from '../form';
import { LevelFormDialog } from '../levelFormDialog/LevelFormDialog';

import { levelsService } from 'v2/api/levelsService';
import { LevelForm } from 'v2/types/LevelModel';
import { handleHttpError } from 'v2/utils';

interface AddLevelButtonProps {
  nextLevel: number;
  onSuccess: VoidFunction;
}

export const AddLevelButton: FC<AddLevelButtonProps> = ({ nextLevel, onSuccess }) => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  const { trigger: triggerCreate, isMutating: isMutatingCreate } = useSWRMutation(
    'createLevel',
    levelsService.createLevel,
    {
      onSuccess: () => {
        onSuccess();
        toast.success('New level has been successfully created');
        setOpen();
      },
      onError: handleHttpError,
    }
  );

  const handleSubmit = (values: LevelForm, resetForm: VoidFunction) => {
    triggerCreate(addProp(values, 'level', nextLevel)).then(() => {
      resetForm();
    });
  };

  return (
    <Fragment>
      <Button onClick={setOpen} startIcon={<Plus />} variant="contained" size="large">
        Add Level
      </Button>

      <LevelFormDialog
        title="Set Up New Level"
        isOpen={isOpen}
        onClose={setOpen}
        initialValues={initialValues}
        level={nextLevel}
        isSubmitting={isMutatingCreate}
        onSubmit={handleSubmit}
      />
    </Fragment>
  );
};
